export { triggerSegmentPropertyEvent } from './triggerSegmentPropertyEvent';
